<template>
  <div class="container-fluid-play mt-3">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-7 mt-5">
          <h2 class="featured-text">DESTACADOS</h2>
          <h3 class="playtexto">Cuatro meses en el hospital</h3>
          <p class="playtext">Parte de la cultura del beisbol de las Grandes Ligas es, sin duda, los entrenamientos de primavera y Jaime ha estado presente en muchos de ellos con su equipo del alma, los Dodgers. Hasta ahí nada de especial, sin embargo, en la primavera de 1990 su vida dio un vuelco.
          Mientras cubría los juegos de pretemporada del equipo en Vero Beach, Florida, tuvo un accidente automovilístico que lo dejó al borde de la muerte. 
          Durante seis semanas estuvo en terapía intensiva y las lesiones internas -gravísimas- lo obligaron estar en el hospital por cuatro meses. “Allí nací otra vez”, suele recordar cuando habla de ese momento. Ese mismo año, ya para el final de la temporada, Jarrín volvió al micrófono para narrar los juegos de los Dodgers.</p>
          <h3 class="playtexto">Fundación para apoyar a estudiantes</h3>
          <p class="playtext">Después de la muerte de Blanca, su esposa, encontró una manera de   
          La institución está comprometida a servir y apoyar programas benéficos, educativos y deportivos en el área local de Los Ángeles. La misión es ayudar a los estudiantes a desbloquear todo su potencial y alcanzar sus metas. Para recaudar fondos han organizados torneos de golf, cenas de gala, además de alianzas para concretar la posibilidad de otorgar becas a los estudiantes.</p>
        </div>
      </div>
     
    </div>
  </div>
 
</template>

<script>
 
	export default {
		name: 'Destacados',
   
		props: {
		msg: String
		}
	}
</script>